import { render, staticRenderFns } from "./red-bag.vue?vue&type=template&id=679281c3&"
import script from "./red-bag.vue?vue&type=script&lang=js&"
export * from "./red-bag.vue?vue&type=script&lang=js&"
import style0 from "./red-bag.vue?vue&type=style&index=0&id=679281c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports